export default __webpack_public_path__ + "static/media/LogoViutifyHorizontal.125076e5.svg";